export default __webpack_public_path__ + "static/IBMPlexSans-SemiBold-Latin2-1ac9d0b721a47c618f27a973427e9f36.woff2";